<template>
  <div>
    起始
   <el-input v-model="postForm.origin" style="width: 200px;"></el-input>
   目标
   <el-input v-model="postForm.destination" style="width: 200px;"></el-input>
   <el-button type="info" @click="clickpost">提交</el-button>
   <div id="allmap" class="bm-view"></div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      postForm: {
        origin: '31.814908,119.90125',
        destination: '31.799298,119.904381'
      },
      map: null,
      zoom: 21,
      stepindex: 0
    }
  },
  mounted () {
    var that = this
    that.$nextTick(() => {
      that.init()
    })
  },
  methods: {
    init () {
      this.map = new BMapGL.Map('allmap')
      var point = new BMapGL.Point(119.90125, 31.814908)
      this.map.centerAndZoom(point, this.zoom)
      this.map.enableScrollWheelZoom(true)

      var that = this
      var scaleCtrl = new BMapGL.ScaleControl() // 添加比例尺控件
      this.map.addControl(scaleCtrl)
      var zoomCtrl = new BMapGL.ZoomControl() // 添加比例尺控件
      this.map.addControl(zoomCtrl)
      var navi3DCtrl = new BMapGL.NavigationControl3D() // 添加3D控件
      this.map.addControl(navi3DCtrl)
      this.map.addEventListener('click', function (e) {
        that.postForm.origin = '' + e.latlng.lat + ',' + e.latlng.lng
      })
      this.map.addEventListener('rightclick', function (e) {
        that.postForm.destination = '' + e.latlng.lat + ',' + e.latlng.lng
      })
    },
    clickpost () {
      this.init()
      this.apiBmapDirectionWalking()
    },
    drawCircle (lng, lat) {
      var fillColor = 'red'
      if (this.stepindex % 2 === 1) {
        fillColor = 'green'
      }

      var circle = new BMapGL.Circle(new BMapGL.Point(lng, lat), 1, {
        fillColor: fillColor,
        strokeWeight: 0
      })
      this.map.addOverlay(circle)

      this.stepindex++
    },
    drawPolyline (lng1, lat1, lng2, lat2) {
      var polyline = new BMapGL.Polyline([
        new BMapGL.Point(lng1, lat1),
        new BMapGL.Point(lng2, lat2)
      ], { strokeColor: 'blue', strokeWeight: 2, strokeOpacity: 0.5 })
      this.map.addOverlay(polyline)
    },
    drawMarker (lng1, lat1, lng2, lat2) {
      // https://erp-1256233047.cos.ap-shanghai.myqcloud.com/arrow.jpg
      // https://pic4.zhimg.com/v2-01ba45fbb10d2488058c4a1abd05ed5e_xl.jpg
      var myIcon = new BMapGL.Icon('https://erp-1256233047.cos.ap-shanghai.myqcloud.com/arrow4.png', new BMapGL.Size(32, 32), {
        anchor: new BMapGL.Size(16, 16),
        imageOffset: new BMapGL.Size(0, 0)
      })
      var marker = new BMapGL.Marker(new BMapGL.Point(lng2, lat2), { icon: myIcon })
      this.map.addOverlay(marker)

      var angle = Math.atan2((lng1 - lng2), (lat1 - lat2))// 弧度  0.9272952180016122
      var theta = angle * (180 / Math.PI)// 角度  53.13010235415598
      if (theta < 0) {
        theta += 360
      }
      marker.setRotation(theta)
    },
    drawLabel (lng, lat, action) {
      if (action.length > 0) {
        var point = new BMapGL.Point(lng, lat)
        var content = action
        var label = new BMapGL.Label(content, { // 创建文本标注
          position: point,
          offset: new BMapGL.Size(10, 20)
        })
        this.map.addOverlay(label) // 将标注添加到地图中
        label.setStyle({ // 设置label的样式
          color: '#000',
          fontSize: '30px',
          border: '2px solid #1E90FF'
        })
      }
    },
    apiBmapDirectionWalking: function () {
      var that = this
      var data = {
        origin: that.postForm.origin,
        destination: that.postForm.destination
      }
      axios.post(Vue.prototype.global.Url_BmapDirectionWalking, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === '200') {
            that.map.clearOverlays()
            var shanglng = ''
            var shanglat = ''
            response.data.BmapStep.filter((item, i) => {
              if (i === 0) {
                var point = new BMapGL.Point(item.lng, item.lat)
                that.map.centerAndZoom(point, that.zoom)
              } else {
                that.drawMarker(item.lng, item.lat, shanglng, shanglat)
                that.drawPolyline(item.lng, item.lat, shanglng, shanglat)
              }
              shanglng = item.lng
              shanglat = item.lat
              that.drawCircle(item.lng, item.lat)
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style>
  .bm-view {
    width: 100%;
    height: 680px;
  }
</style>
